import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService } from 'partnerhub';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { AuthenticatedUser, User } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private readonly http: HttpClient, private readonly helperService: HelperService) {}

  public getUserById(userId: number): Observable<User> {
    const url = `/mock/users/${userId}`;

    return this.http.get<User>(url).pipe(pluck('responseData'));
  }

  public getUserDetails(): Observable<AuthenticatedUser> {
    const url = `/api/webapp-partnerhub-admin/users/details`;

    return this.http.get(url).pipe(pluck('responseData'));
  }

  public getUsers(
    offset: number = null,
    pageIncrement: number = null
  ): Observable<{ responseData: any[]; totalResultSize: number }> {
    // BE: Waiting for Endpoint
    const url = `/mock/users`;

    const queryParameters = this.helperService.setHttpQueryParameters([
      { name: 'offset', value: offset },
      { name: 'limit', value: pageIncrement },
    ]);

    return this.http.get<{ responseData: any[]; totalResultSize: number }>(url);
  }
}
